/**
 * Converts letter runs that are ALL CAPS (2+ letters) to title case within rich text.
 * Skips script/style/code/pre. Safe for Greek + Latin (Unicode letters).
 */
(function () {
  function normalizeLetterRun(letters) {
    if (letters.length < 2) return letters;
    if (letters !== letters.toUpperCase()) return letters;
    return letters.charAt(0).toUpperCase() + letters.slice(1).toLowerCase();
  }

  function normalizeTextValue(text) {
    return text.replace(/\p{L}+/gu, normalizeLetterRun);
  }

  function shouldSkipTextNode(textNode) {
    let el = textNode.parentElement;
    while (el) {
      const tag = el.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'CODE' || tag === 'PRE' || tag === 'KBD' || tag === 'SAMP') {
        return true;
      }
      el = el.parentElement;
    }
    return false;
  }

  function walkAndNormalize(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    const nodes = [];
    let n;
    while ((n = walker.nextNode())) {
      if (shouldSkipTextNode(n)) continue;
      if (!n.nodeValue || !/\p{L}/u.test(n.nodeValue)) continue;
      nodes.push(n);
    }
    nodes.forEach((textNode) => {
      const next = normalizeTextValue(textNode.nodeValue);
      if (next !== textNode.nodeValue) textNode.nodeValue = next;
    });
  }

  function run() {
    document.querySelectorAll('[data-description-normalize-caps]').forEach((root) => {
      if (root.dataset.descriptionNormalizeCaps === 'done') return;
      walkAndNormalize(root);
      root.dataset.descriptionNormalizeCaps = 'done';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
